import useTranslate from "hooks/useTranslate";

export const getTimeWord = (
  t: ReturnType<typeof useTranslate>,
  minutes: number,
) => {
  if (minutes > 1440 * 2) {
    return t("loyalty.days");
  }

  if (minutes > 1440) {
    return t("loyalty.day");
  }

  if (minutes > 60) {
    return t("loyalty.hours");
  }

  return t("loyalty.hour");
};
